// The project picker on the sign-off pages: the caller's projects (GET /projects/picker), plus
// the open one when it is not among them - a project opened through an admin's or overseer's
// access showed as its raw id (2026-10-30). `title` comes from the timeline (projectTitle).
export function pickerOptions(projects, projectId, title) {
  const out = (projects || []).map((p) => ({ value: String(p._id), label: p.title || p.name || "Project" }));
  if (projectId && !out.some((o) => o.value === String(projectId))) out.unshift({ value: String(projectId), label: title || "This project" });
  return out;
}
